"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityQuoteTaxMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_quote_entry_entity_1 = require("./opportunity-quote-entry.entity");
let OpportunityQuoteTaxMap = class OpportunityQuoteTaxMap {
};
exports.OpportunityQuoteTaxMap = OpportunityQuoteTaxMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteTaxMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_quote_entry_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteTaxMap.prototype, "opportunityQuoteEntryId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "tax_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityQuoteTaxMap.prototype, "taxLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "tax_value", type: "numeric", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityQuoteTaxMap.prototype, "taxValue", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], OpportunityQuoteTaxMap.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], OpportunityQuoteTaxMap.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteTaxMap.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteTaxMap.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_quote_entry_entity_1.OpportunityQuoteEntry, (entry) => entry.taxMappings, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_quote_entry_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityQuoteTaxMap.prototype, "quoteEntry", void 0);
exports.OpportunityQuoteTaxMap = OpportunityQuoteTaxMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_quote_tax_map")
], OpportunityQuoteTaxMap);
